import {inject, Pipe, PipeTransform} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

@Pipe({
  name: 'standaloneMode',
  standalone: false,
})
export class StandaloneModePipe implements PipeTransform {
  private readonly translate = inject(TranslateService);

  transform(value: boolean) {
    if (value === true) {
      return this.translate.instant('enums.recipientMode.standalone');
    } else if (value === false) {
      return this.translate.instant('enums.recipientMode.fund');
    }
  }
}
